export default __webpack_public_path__ + "static/media/twitter.707fd7b9.svg";